<template>
    <div>
        <div v-if="!voiceOptions">
            <h4>Choisir un preset :</h4>
            <br>
            <div style="margin-left:2.5%;width:95%">
                <div v-if="presets.length">
                    <div>
                        <label>Presets :</label>
                        &nbsp;
                        <input type="radio" v-model="genderFilter" :value="null">
                        <label>Tous genres</label>
                        &nbsp;
                        <input type="radio" v-model="genderFilter" value="1">
                        <label>Homme</label>
                        &nbsp;
                        <input type="radio" v-model="genderFilter" value="2">
                        <label>Femme</label>
                        &nbsp;
                        <input type="radio" v-model="genderFilter" value="3">
                        <label>Neutre</label>
                    </div>
                    <br>
                    <multiselect
                        v-model="voiceOptions"
                        ref="presetSelect"
                        :options="presets"
                        label="label"
                        track-by="label"
                        :reset-after="false"
                        placeholder="Preset"
                        selectLabel="Sélectionner"
                        selectedLabel="Sélectionné"
                        deselectLabel="Annuler"
                        tag-placeholder="Sélectionner"
                    >
                        <template slot="noResult">
                            <span>Aucun preset ne correspond à votre recherche.</span>
                        </template>
                        <template slot="noOptions">
                            <span>Aucun preset n'a été défini.</span>
                        </template>    
                    </multiselect>
                    <br>                    
                </div>
                <div style="text-align:center">
                    <span v-if="presets.length">OU&nbsp;</span>
                    <button class="button btn btn-info" @click="voiceOptions = {label: '', voiceName: 'fr-FR-Wavenet-A', pitch: 0.00, speakingRate: 1.00, gender: 'FEMALE'}">Nouveau preset</button>                
                </div>
            </div>
        </div>
        <div v-else>
            <button class="button btn btn-info" @click="voiceOptions = null; clearTestVoiceFile();">Retour</button>
            <br>
            <br>
            <div v-if="voiceOptions.id">
                <button class="button btn btn-info pull-right" @click="newPresetFromExisting()">Nouveau preset</button>                
                <div class="form-group">
                    <label>Nom : {{ voiceOptions.label }}</label>
                </div>
                <div class="form-group">
                    <label>Voix : {{ voiceOptions.voiceName }}</label>
                </div>
                <div class="form-group">
                    <label>Vitesse : {{ voiceOptions.speakingRate }}</label>
                </div>
                <div class="form-group">
                    <label>Hauteur de la voix: {{ voiceOptions.pitch }} demi-ton(s)</label>
                </div>                
            </div>
            <div v-else>
                <div class="form-group">
                    <label>Nom : </label>
                    <input class="form-control" type="text" v-model="voiceOptions.label">                
                </div>
                <div class="form-group">
                    <label>Voix : </label>
                    <v-select v-model="voiceOptions.voiceName" @change="changeVoiceSelection()">
                        <v-option v-for="(availableVoice, index) in availableVoices" :value="availableVoice.voiceName" :key="availableVoice.voiceName">{{ availableVoice.voiceName + ' - ' + voiceGenders[availableVoice.gender] }}</v-option>
                    </v-select>
                </div>
                <div class="form-group">
                    <label>Vitesse : {{ voiceOptions.speakingRate }}</label>
                    <button v-if="voiceOptions.speakingRate != 1.00" class="button btn btn-info pull-right" @click="resetSpeakingRate()">Réinitialiser</button>
                    <br>
                    <br>
                    <vue-slider
                        @change="clearTestVoiceFile()"
                        tooltip="none"
                        :interval="0.01"
                        v-model="voiceOptions.speakingRate"
                        :min="0.25"
                        :max="4"
                    ></vue-slider>
                </div>
                <div class="form-group">
                    <label>Hauteur de la voix: {{ voiceOptions.pitch }} demi-ton(s)</label>
                    <button v-if="voiceOptions.pitch != 0.00" class="button btn btn-info pull-right" @click="resetPitch()">Réinitialiser</button>
                    <br>
                    <br>
                    <vue-slider
                        @change="clearTestVoiceFile()"
                        tooltip="none"
                        :interval="0.1"
                        v-model="voiceOptions.pitch"
                        :min="-20"
                        :max="20"
                    ></vue-slider>
                </div>
            </div>
            <button v-show="!testVoiceFileBlobUrl" class="button btn btn-info pull-right" @click="testVoice()">Tester la voix</button>
            <audio
                v-show="testVoiceFileBlobUrl"
                ref="testVoicePlayer"
                controls>
            </audio>
            <br>
            <br>
        </div>
    </div>
</template>

<script>
import { select as VSelect, option as VOption }  from 'vue-strap'
import VueSlider from 'vue-slider-component';
import 'vue-slider-component/theme/default.css'
import Multiselect from 'vue-multiselect'

import "vue-multiselect/dist/vue-multiselect.min.css"

export default {
    name: 'VoiceSelection',
    components: {
        VSelect,
        VOption,
        VueSlider,
        Multiselect
    },                                                             
    props: {
        text: {
            type: String,
            default: 'Ceci est un test.'
        },
        voicePreset: {
            type: Object,
            default: null
        }
    },                           
    data: function()    {
        return {
            testVoiceFileBlobUrl: null,
            voiceGenders: {
                'MALE': "Homme",
                'FEMALE': "Femme",
                'NEUTRAL': "Neutre"
            },
            defaultVoices: [
                {voiceName: 'fr-FR-Wavenet-A', gender: 'FEMALE'},
                {voiceName: 'fr-FR-Wavenet-B', gender: 'MALE'},
                {voiceName: 'fr-FR-Wavenet-C', gender: 'FEMALE'},
                {voiceName: 'fr-FR-Wavenet-D', gender: 'MALE'},
                {voiceName: 'fr-FR-Wavenet-E', gender: 'FEMALE'},
                {voiceName: 'fr-FR-Neural2-A', gender: 'FEMALE'},
                {voiceName: 'fr-FR-Neural2-B', gender: 'MALE'},
                {voiceName: 'fr-FR-Neural2-C', gender: 'FEMALE'},
                {voiceName: 'fr-FR-Neural2-D', gender: 'MALE'},
                {voiceName: 'fr-FR-Neural2-E', gender: 'FEMALE'}
            ],
            genderFilter: null,
            voiceOptions: null
        };
    },                                                    
    computed: {
        presets() {
            return this.genderFilter ? this.$store.state.admin.voicePresets.filter(item => item.gender == this.genderFilter) : this.$store.state.admin.voicePresets;
        },
        availableVoices() {
            return this.$store.state.admin.voices.length ? this.$store.state.admin.voices : this.defaultVoices;
        }
    },   
    methods: {
        newPresetFromExisting() {
            this.voiceOptions = Object.assign({}, this.voiceOptions, {id: null, label: ''});
        },
        changeVoiceSelection() {
            // assign gender in voiceOptions data
            // Object.assign(this.voiceOptions);
            this.clearTestVoiceFile();
        },
        resetPitch() {
            this.voiceOptions.pitch = 0.00;
            this.clearTestVoiceFile();
        },
        resetSpeakingRate() {
            this.voiceOptions.speakingRate = 1.00;
            this.clearTestVoiceFile();
        },
        clearTestVoiceFile() {
            this.testVoiceFileBlobUrl = null;
        },
        testVoice() {
            let self = this;
            this.$store.dispatch('textToSpeech', {
                textToSpeechData: Object.assign(this.voiceOptions, {text: this.text, test: true}),
                voiceOptions: this.voiceOptions,
                callbacks: {
                    success(blobUrl) {
                        self.$refs.testVoicePlayer.src = blobUrl;
                        self.testVoiceFileBlobUrl = blobUrl;
                    }
                }
            }).then(() => {

            });
        }
    },
    created() {
        this.voiceOptions = this.voicePreset;
    }
}
</script>

<style></style>